import { createAction } from '@reduxjs/toolkit';

export const init = createAction('USER_INIT');
export const updateConsent = createAction('USER_UPDATE_CONSENT');
